import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import "../styles/Services.css";

function Services() {
  return (
    <div>
      <Navbar />

      <section className="services-page">
        <h1>Our Services</h1>
        <p className="subtitle">
          Explore what we offer at Bomander Travels Limited
        </p>

        
        <div className="service-block">
          <img
            src="https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=900&auto=format&fit=crop&q=60"
            alt="Tourism"
          />

          <p>
           At our travel agency, we specialize in providing <b>seamless and reliable Tourism and Visitor Visa assistance</b>
          for individuals and families planning to travel abroad for leisure, vacation, sightseeing, or to visit friends and relatives.
          We make the entire process <i>simple, stress-free, and well-guided</i>.
            <Link to="/tourism" className="read-more"> Read more</Link>
          </p>
        </div>

        
        <div className="service-block">
          <img
            src="https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?w=600&auto=format&fit=crop&q=60"
            alt="Study"
          />

          <p>
           Our agency provides <b>comprehensive University Admission and Study Visa assistance</b> for students who wish to pursue higher education abroad.
          We guide you from <i>application to visa approval and arrival</i> at your chosen institution.
            <Link to="/study" className="read-more"> Read more</Link>
          </p>
        </div>

        
        <div className="service-block">
          <img
            src="https://images.unsplash.com/photo-1551434678-e076c223a692?w=900&auto=format&fit=crop&q=60"
            alt="Work"
          />

          <p>
            Our agency provides <b>professional and reliable Work Sponsorship Visa services</b> for individuals seeking employment opportunities abroad.
          We help you connect with legitimate employers and guide you through the entire <i>visa sponsorship and immigration process</i>.
            <Link to="/work" className="read-more"> Read more</Link>
          </p>
        </div>

        
        <div className="service-block">
          <img
            src="https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=900&auto=format&fit=crop&q=60"
            alt="Conference"
          />

          <p>
            An <b>Academic Conference Application</b> involves registering for and gaining approval to attend or present at an international academic event
            such as a conference, seminar, workshop, or symposium.
            <Link to="/conference" className="read-more"> Read more</Link>
          </p>
        </div>

      </section>

      <Footer />
    </div>
  );
}

export default Services;